import { defaultFill } from '../../utils/constants';
var muiCheckMark16 = {
    paths: [
        {
            path: 'M4.63938053,12 C5.0420354,12 5.35176991,11.8339022 5.56858407,11.5017065 L11.7809735,1.64505119 C11.8561947,1.5221843 11.9115044,1.40386803 11.9469027,1.29010239 C11.9823009,1.17633675 12,1.06484642 12,0.955631399 C12,0.678043231 11.9103982,0.449374289 11.7311947,0.269624573 C11.5519912,0.0898748578 11.3252212,0 11.050885,0 C10.8606195,0 10.7002212,0.0386803185 10.5696903,0.116040956 C10.4391593,0.193401593 10.3163717,0.327645051 10.2013274,0.518771331 L4.61283186,9.6109215 L1.75221239,5.9112628 C1.53982301,5.63822526 1.27654867,5.50170648 0.962389381,5.50170648 C0.683628319,5.50170648 0.453539823,5.59385666 0.272123894,5.778157 C0.0907079646,5.96245734 0,6.19567691 0,6.4778157 C0,6.60523322 0.0210176991,6.72696246 0.0630530973,6.84300341 C0.105088496,6.95904437 0.17920354,7.07849829 0.28539823,7.20136519 L3.71681416,11.5358362 C3.96460177,11.8452787 4.27212389,12 4.63938053,12 Z',
            fill: defaultFill,
        },
    ],
    title: 'Check Mark',
    width: 12,
    height: 12,
};
var muiCheckMark = {
    base: muiCheckMark16,
};
export { muiCheckMark };
//# sourceMappingURL=checkMark.js.map